import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { RadioGroup, FormControlLabel, Radio, Box } from '@material-ui/core'
import { useIntl } from 'react-intl'
import FrequencyUnit from 'app/componentV4/frequencys/FrequencyUnit'
import { useFormikContext } from 'formik'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import { isNil } from 'ramda'

const FrequencyTypeSelector = ({ value }) => {
  const formik = useFormikContext()

  const { error, touched } = formik.getFieldMeta('duration')

  const isError = !isNil(error) && touched

  const [frequencyType, setFrequencyType] = useState(value)
  const { formatMessage } = useIntl()
  const labelSentAfter = formatMessage({
    id: 'createNotificationBeacon.dialog.frequency.selected.title',
  })
  const labelSentOnce = formatMessage({
    id: 'createNotificationBeacon.dialog.frequency.sendOnlyOnce.label',
  })

  const handleFrequencyChange = (type) => {
    setFrequencyType(type)
    if (type === 'once') {
      formik.setFieldValue('duration', '')
      formik.setFieldValue('frequencyUnit', 'hour')
    }
    formik.setFieldValue('frequencyType', type)
  }

  return (
    <RadioGroup
      name="frequencyType"
      value={frequencyType}
      onChange={(event) => handleFrequencyChange(event.target.value)}
    >
      <Box display="flex" alignItems="center">
        <FormControlLabel
          value="once"
          control={<Radio />}
          label={labelSentOnce}
        />
      </Box>
      <div className="sm:flex h-auto">
        <Box display="flex" alignItems="center">
          <FormControlLabel
            value="repeat"
            control={<Radio />}
            label={labelSentAfter}
          />
        </Box>
        <Box display="flex" ml={2}>
          <FrequencyUnit onFrequencyChange={handleFrequencyChange} />
        </Box>
      </div>
      {isError && (
        <div className="flex space-x-2 py-2">
          <div className="flex my-auto">
            <ErrorOutlineIcon className="text-red-500" fontSize="small" />
          </div>
          <label className="text-red text-14">{formik.errors.duration}</label>
        </div>
      )}
    </RadioGroup>
  )
}

FrequencyTypeSelector.propTypes = {
  value: PropTypes.string.isRequired,
}

export default FrequencyTypeSelector
